var _style, _path, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#050505;stroke-miterlimit:10;}\n\t.st1{fill:#050505;}\n\t.st2{opacity:0.5;fill:#050505;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,21.6L12.3,21.6L12.3,21.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.4,23c-0.6,0-1.3-0.3-1.7-0.7c0,0,0,0,0,0l-10-10C1.3,11.8,1,11.2,1,10.6s0.3-1.3,0.7-1.7l7.1-7.1 c0.9-0.9,2.5-0.9,3.4,0l10,10c0.6,0.6,0.8,1.4,0.7,2.2l-1.1,6c-0.2,1-1,1.8-2,2l-6,1.1C13.7,23,13.6,23,13.4,23z M13.1,20.9 c0.1,0.1,0.2,0.1,0.4,0.1l6-1.1c0.2,0,0.3-0.2,0.3-0.3l1.1-6c0-0.1,0-0.3-0.1-0.4l-10-10c-0.2-0.2-0.4-0.2-0.6,0l-7.1,7.1 c-0.2,0.2-0.2,0.4,0,0.6L13.1,20.9z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 16.4,
    cy: 16,
    r: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProducts);
export default __webpack_public_path__ + "static/media/icon-products.90c2128003f0a56dbdc5d43aac5b33c9.svg";
export { ForwardRef as ReactComponent };